// components/LegalRepresentatives/AccountRepresentativesFilterBar.js

const AccountRepresentativesFilterBar = ({ filters, onFiltersChange, loading, onReset }) => {
  const handleSearchChange = (e) => {
    onFiltersChange({ search: e.target.value });
  };

  const handleStatusChange = (e) => {
    onFiltersChange({ status: e.target.value || null });
  };

  const handleMandateTypeChange = (e) => {
    onFiltersChange({ mandateType: e.target.value || null });
  };

  const handleSortChange = (e) => {
    onFiltersChange({ sortBy: e.target.value });
  };

  const handleSortOrderChange = (e) => {
    onFiltersChange({ sortDescending: e.target.value === 'true' });
  };

  const statusOptions = [
    { value: '', label: 'Tous les statuts' },
    { value: 'ACTIVE', label: 'Actif' },
    { value: 'INACTIVE', label: 'Inactif' },
    { value: 'PENDING', label: 'En attente' },
    { value: 'EXPIRED', label: 'Expiré' }
  ];

  const mandateTypeOptions = [
    { value: '', label: 'Tous les types' },
    { value: 'TUTORSHIP', label: 'Tutelle' },
    { value: 'CURATORSHIP', label: 'Curatelle' },
    { value: 'POWER_OF_ATTORNEY', label: 'Procuration' },
    { value: 'LEGAL_GUARDIAN', label: 'Représentant Légal' },
    { value: 'PARENT', label: 'Parent' }
  ];

  const sortOptions = [
    { value: 'CreationDate', label: 'Date de création' },
    { value: 'StartDate', label: 'Date de début' },
    { value: 'representativeLastName', label: 'Nom du représentant' },
    { value: 'mandateType', label: 'Type de mandat' },
    { value: 'status', label: 'Statut' }
  ];

  return (
    <div className="card mb-4 border-0 shadow-sm">
      <div className="card-body">
        <div className="row g-3 align-items-end">
          {/* Recherche */}
          <div className="col-md-3">
            {/* <label className="form-label fw-semibold">Recherche</label> */}
            <input
              type="text"
              className="search-input"
              placeholder="Nom, email..."
              value={filters.search}
              onChange={handleSearchChange}
              disabled={loading}
            />
          </div>

          {/* Filtre Statut */}
          <div className="col-md-2">
            {/* <label className="form-label fw-semibold">Statut</label> */}
            <select
              className="account-type-select"
              value={filters.status || ''}
              onChange={handleStatusChange}
              disabled={loading}
            >
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Filtre Type de Mandat */}
          <div className="col-md-2">
            {/* <label className="form-label fw-semibold">Type de mandat</label> */}
            <select
              className="account-type-select"
              value={filters.mandateType || ''}
              onChange={handleMandateTypeChange}
              disabled={loading}
            >
              {mandateTypeOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Tri */}
          <div className="col-md-2">
            {/* <label className="form-label fw-semibold">Trier par</label> */}
            <select
              className="account-type-select"
              value={filters.sortBy}
              onChange={handleSortChange}
              disabled={loading}
            >
              {sortOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Ordre de tri */}
          <div className="col-md-2">
            {/* <label className="form-label fw-semibold">Ordre</label> */}
            <select
              className="account-type-select"
              value={filters.sortDescending.toString()}
              onChange={handleSortOrderChange}
              disabled={loading}
            >
              <option value="true">Décroissant</option>
              <option value="false">Croissant</option>
            </select>
          </div>

          {/* Bouton Reset */}
          <div className="col-md-1">
            <button
              type="button"
              className="filter-button"
              onClick={onReset}
              disabled={loading}
              title="Réinitialiser les filtres"
            >
              <i className="fas fa-refresh"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountRepresentativesFilterBar;